import { render, staticRenderFns } from "./lds-spinner.vue?vue&type=template&id=3ad82ffd&scoped=true&"
import script from "./lds-spinner.vue?vue&type=script&lang=js&"
export * from "./lds-spinner.vue?vue&type=script&lang=js&"
import style0 from "./lds-spinner.vue?vue&type=style&index=0&id=3ad82ffd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad82ffd",
  null
  
)

export default component.exports